import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Karagandy_obl.png'
import _imports_1 from '@/assets/images/karagandy1.jpg'
import _imports_2 from '@/assets/images/karagandy2.jpg'
import _imports_3 from '@/assets/images/karagandy3.jpg'
import _imports_4 from '@/assets/images/karagandy4.jpg'
import _imports_5 from '@/assets/images/karagandy5.jpg'
import _imports_6 from '@/assets/images/karagandy6.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Карагандинская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " В Карагандинскойя области на сегодняшний день преимущественно развит внутренний туризм, статистика показывает, что местные жители охотнее всего посещают в регионе Каркаралинский природный парк и побережье озера Балхаш. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "«Зеленые» Туры")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Экологический туризм – самое перспективное на сегодня направление туристической деятельности в окрестностях Караганды. Регион находится в наивысшей части Казахского мелкосопочника, которая отличается оригинальным неоднородным рельефом, и эту особенность турфирмы используют при составлении маршрутов для пеших походов. Здесь можно встретить холмы и глубокие речные долины, сухие русла старых потоков, озерные котловины. Любителей острых ощущений привлекут высокие скальные выходы на поверхность и каменистые россыпи. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Популярными являются рыболовные туры по региону. Хоть местные реки и маловодные, но в них в достаточном количестве водятся сом, линь, щука, плотва, язь. Они же и некоторые другие виды рыб отлично ловятся в озере "),
          /*#__PURE__*/_createVNode("b", null, "Балхаш"),
          /*#__PURE__*/_createTextVNode(". Статистика туризма в Казахстане утверждает, что на Балхаш ездят не только с целью заняться спортивным рыболовством. Популярными видами отдыха, помимо пляжного, здесь стали лодочные прогулки, катания на катерах и яхтах. ")
        ]),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("b", null, "Каркаралинский национальный парк"),
          /*#__PURE__*/_createTextVNode(" – настоящий кладезь интересных туристических маршрутов. Самыми популярными направлениями можно назвать походы к мистическому озеру Шайтанколь, в Кызыл-Кентский дворец (бывший Буддийский монастырь). Кроме того, здесь можно поправить здоровье в одном из многочисленных домов отдыха. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col" }, [
  /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Куда Едут Иностранные Туристы")
], -1)
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "region-way-text" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Статистика туризма в Карагандинской области говорит, что среди иностранных путешественников более востребованы экскурсии в горы ")
const _hoisted_9 = /*#__PURE__*/_createVNode("b", null, "Улытау", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" – эта местность имеет важное значение в истории Казахского ханства. Когда-то здесь находилась ставка Джучи – старшего сына Чингисхана, а позже – хана Батыя. С тех времен в в регионе остались курганы и мавзолеи. А еще здесь можно увидеть сохранившиеся части старинных металлургических печей, в которых выплавляли золото, медь и другие металлы. ")
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Не менее популярна у иностранных туристов и сама Караганда. Этот город-полумилллионник достаточно молод – ему пока не исполнилось и сотни лет. Однако здесь есть что посмотреть: этнопарк, зоопарк, цирк, несколько музеев, в частности единственный в Казахстане – "),
  /*#__PURE__*/_createVNode("b", null, "Музей-Шахта"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "11982")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "21,1")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "298465")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "21198")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " ЗКО имеет богатую историю, здесь множество природных и культурных достопримечательностей, сакральных мест. Как развивается туризм в Западно-Казахстанской области? В регионе разработаны интересные маршруты, нет дефицита в грамотных экскурсоводах, поездки осуществляются на автобусах, отвечающих современным требованиям. ")
    ])
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "regio-swiper" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_6
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_P = _resolveComponent("P")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_P, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _hoisted_11
          ])
        ])
      ])
    ]),
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}